import { TextEditor } from '@approvalmax/ui';
import { memo, useCallback } from 'react';

import { FieldInputProps } from './FieldInput.types';

const FieldInput = memo<FieldInputProps>((props) => {
    const { field, formValue, setFormValues, setFieldsTouched, setValidationErrors, validationErrors } = props;

    const changeHandler = useCallback(
        (value: string) => {
            setFormValues((prevFormValues) => ({ ...prevFormValues, [field.path]: value }));
            setFieldsTouched((prevFieldsTouched) => ({ ...prevFieldsTouched, [field.path]: true }));
        },
        [field.path, setFieldsTouched, setFormValues]
    );

    const blurHandler = useCallback(() => {
        if (setValidationErrors && field.rule?.pattern) {
            if (!formValue && !field.required) {
                const newValidationErrors = { ...validationErrors };

                delete newValidationErrors[field.path];
                setValidationErrors(newValidationErrors);
            } else if (!new RegExp(field.rule?.pattern).test(formValue)) {
                setValidationErrors({
                    ...validationErrors,
                    [field.path]: true,
                });
            } else {
                const newValidationErrors = { ...validationErrors };

                if (newValidationErrors[field.path]) {
                    delete newValidationErrors[field.path];
                    setValidationErrors(newValidationErrors);
                }
            }
        }
    }, [field.path, field.required, field.rule?.pattern, formValue, setValidationErrors, validationErrors]);

    return (
        <TextEditor
            key={field.path}
            value={formValue}
            placeholder={field.field.placeholder}
            disabled={!field.enabled}
            invalid={validationErrors && validationErrors[field.path]}
            onChange={changeHandler}
            onBlur={blurHandler}
        />
    );
});

export default FieldInput;
